import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-deposit-grid',
  templateUrl: './new-deposit-grid.component.html',
  styleUrls: ['./new-deposit-grid.component.css']
})
export class NewDepositGridComponent implements OnInit {
  title="NewDepositList"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/new-deposit-grid/new-deposit-grid.component.ts